import AllEntryPage from "./AllEntryPage";

export default AllEntryPage;
